import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { TicketStatus, TicketStatusTitle } from '../../../../store/ticket';

interface TicketActionsProps {
  ticketId: string;
  status?: TicketStatus;
  updateLoading?: boolean;
  deleteLoading?: boolean;
  onResolve: (ticketId: string) => void;
  onOpen: (ticketId: string) => void;
  onDelete: (ticketId: string) => void;
}

export default function TicketActions({
  ticketId,
  status,
  updateLoading,
  deleteLoading,
  onResolve,
  onOpen,
  onDelete,
}: TicketActionsProps): JSX.Element {
  return (
    <>
      {status === TicketStatus.OPEN ? (
        <Button loading={updateLoading} onClick={() => onResolve(ticketId)}>
          {TicketStatusTitle[TicketStatus.RESOLVED]}
        </Button>
      ) : (
        <Button type="primary" loading={updateLoading} onClick={() => onOpen(ticketId)}>
          {TicketStatusTitle[TicketStatus.OPEN]}
        </Button>
      )}
      <Button loading={deleteLoading} onClick={() => onDelete(ticketId)} icon={<DeleteOutlined />}>
        Delete
      </Button>
    </>
  );
}
